export enum OperationTypesEnum {
    InComplete = 1,
    Submit = 2,
    EditData=3,
    ForwardCall =4,
}
